function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Give A Hand");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M423.1,341.46,420,340s-1-11.19,0-18.66c2-13.91,11.71-25.9,20.36-27.31,11.14-1.81,9.16,8.44,2.79,12.87C433,314,425.1,324.73,423.1,341.46Z",
  transform: "translate(-31.58 -39.75)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M307.37,341.82a54.22,54.22,0,0,1,2.79-11.74s-1.29-10.1-2-19.8c-1.33-17.39-.26-23.07,3.16-30.87,0,0,29.17-3,30.06,9.17,1.11,15.1-.36,44.28-.76,49.61s-.9,7.74-2.78,18.88c-1.44,8.48-3.66,27.93-3.66,27.93a8,8,0,0,1-7.54-.16s-2.38-24.28-2.13-30.43A52.28,52.28,0,0,1,326.8,341s-1.81-24.61-2.33-28.53c0,0-.92,7.81-1.32,13.14s-2,10.43-3.52,20.34c-1.34,8.59-3.83,27.8-3.83,27.8-3.87,2.1-6.18-.27-6.18-.27S306.33,349.27,307.37,341.82Z",
  transform: "translate(-31.58 -39.75)"
});

var SvgBackground = function SvgBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 440.75 437.52",
    className: "giveahand",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M96.13,443.56c86.06,45,225.6,45,311.66,0s86.06-117.86,0-162.82-225.6-45-311.66,0S10.07,398.6,96.13,443.56Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#f5f5f5"
    }
  }), React.createElement("ellipse", {
    cx: 297.9,
    cy: 345.09,
    rx: 40.89,
    ry: 23.61,
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("ellipse", {
    cx: 372.62,
    cy: 307.07,
    rx: 36.17,
    ry: 20.88,
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M372.08,78.84l6.4,3.69a6.18,6.18,0,0,1-.06-.85V79.83c0-3.3,2.32-4.63,5.17-3a9.82,9.82,0,0,1,3.08,3c.47-4.15,3.72-5.69,7.67-3.41a17.09,17.09,0,0,1,7.73,13.39v2.77a7.32,7.32,0,0,1-.65,3.22l5.31,3.06a6.36,6.36,0,0,1,2.87,5c0,1.83-1.29,2.57-2.87,1.65l-34.65-20a6.35,6.35,0,0,1-2.86-5C369.22,78.66,370.5,77.92,372.08,78.84Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ebebeb"
    }
  }), React.createElement("path", {
    d: "M344.72,97.47l4.83,2.78a4.6,4.6,0,0,1-.05-.64V98.22c0-2.49,1.75-3.5,3.91-2.26a7.7,7.7,0,0,1,2.32,2.24c.35-3.13,2.81-4.29,5.79-2.57a12.89,12.89,0,0,1,5.83,10.11v2.09a5.46,5.46,0,0,1-.49,2.42l4,2.31a4.8,4.8,0,0,1,2.16,3.75c0,1.38-1,1.94-2.16,1.25l-26.15-15.1a4.75,4.75,0,0,1-2.16-3.74C342.56,97.34,343.52,96.78,344.72,97.47Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ebebeb"
    }
  }), React.createElement("path", {
    d: "M78.48,395.78c-.63.34-12.41,3.69-16.77-2.08s2.88-14.74-1.22-18.05-15.55,0-18.31-6.95,5.42-10,.82-17c-2.9-4.42-11-6.86-10.63-11,.54-6,11.61-7.64,21.29-1.19s14.18,1.16,17.26.73,9.69.52,9.47,11.3S78.48,395.78,78.48,395.78Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#455a64"
    }
  }), React.createElement("path", {
    d: "M79.26,380.45a.64.64,0,0,1-.63-.54c-3.37-20.46-27.15-37.11-39.52-40.68a.66.66,0,0,1-.44-.8.64.64,0,0,1,.8-.43c12.64,3.65,37,20.71,40.43,41.7a.65.65,0,0,1-.53.74Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M51.22,363.32a.64.64,0,0,1-.55-.31.65.65,0,0,1,.22-.88c.39-.23,9.54-5.58,18.55-3.08a.64.64,0,0,1,.45.79.63.63,0,0,1-.79.45c-8.48-2.35-17.46,2.89-17.55,2.94A.63.63,0,0,1,51.22,363.32Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M423.1,341.46,420,340s-1-11.19,0-18.66c2-13.91,11.71-25.9,20.36-27.31,11.14-1.81,9.16,8.44,2.79,12.87C433,314,425.1,324.73,423.1,341.46Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref3), React.createElement("path", {
    d: "M421.92,337H422a.54.54,0,0,0,.43-.63c-2.16-11.43,7.25-32.62,19.84-38.64a.54.54,0,0,0-.47-1c-13,6.2-22.66,28-20.44,39.82A.54.54,0,0,0,421.92,337Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M420,340c-.23-1.66-.33-4.08-.36-4.68a15.24,15.24,0,0,1,.91-6.2,12.23,12.23,0,0,1,5.17-6.27c1.3-.75,2.82-1.29,3.66-2.53a8.08,8.08,0,0,0,.95-3.71c.26-2.09.91-4.3,2.59-5.58s4-1.31,6-1.09c3,.32,5.81.72,8.61-.65a58.81,58.81,0,0,1,6.92-3.12c3-1,9.71-2.5,11.12,1.71a4.05,4.05,0,0,1-.61,3.43,12.28,12.28,0,0,1-2.52,2.57l-4.69,3.9a6,6,0,0,0-1.43,1.49c-.91,1.56-.26,3.53-.46,5.32a6.35,6.35,0,0,1-2.88,4.48,8.53,8.53,0,0,1-5.24,1.27c-2.45-.17-6.45-2.05-7.95.84a9.35,9.35,0,0,0-.72,3.1,6,6,0,0,1-1,3c-1,1.22-2.67,1.57-4.23,1.73a24.09,24.09,0,0,0-6.45,1c-.84.33-1.37,1.4-1.86,2.11C424,341.61,422.32,341,420,340Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M421.37,339.16a.47.47,0,0,1-.23,0,.51.51,0,0,1-.28-.66c6.3-15.65,26.4-26.86,38.38-30.58a.5.5,0,0,1,.63.34.51.51,0,0,1-.33.63c-11.79,3.66-31.57,14.66-37.74,30A.52.52,0,0,1,421.37,339.16Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M278.84,311.2a12.38,12.38,0,0,0,5.61,9.71,4.51,4.51,0,0,0,3.22.68,2.81,2.81,0,0,1-.61.48l1.35-.77.07-.05.2-.13a1.79,1.79,0,0,0,.25-.22l.15-.15,0,0c0-.05.09-.1.13-.16a4,4,0,0,0,.46-.84l.1-.27a.74.74,0,0,0,0-.14,2.1,2.1,0,0,0,.06-.24,6.07,6.07,0,0,0,.15-1.4,12.38,12.38,0,0,0-5.6-9.7,5,5,0,0,0-2.51-.77h0l-.35,0-.32.06-.19.05-.12,0a1.09,1.09,0,0,0-.23.09l0,0-.21.11-1.17.67a2.37,2.37,0,0,1,.6-.21A4.46,4.46,0,0,0,278.84,311.2Zm9.23,10.26.1,0Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M162.43,375.72l7.91,13.74,1.34-.78,115.38-66.61a2.81,2.81,0,0,0,.61-.48,4.46,4.46,0,0,0,1-3.15,12.42,12.42,0,0,0-5.61-9.71,5.07,5.07,0,0,0-2.51-.76,2.81,2.81,0,0,0-.71.08,2.37,2.37,0,0,0-.6.21l-.1.05,0,0h0Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ebebeb"
    }
  }), React.createElement("path", {
    d: "M166.4,376.11c-3.1-1.79-5.61-.34-5.61,3.23a12.38,12.38,0,0,0,5.61,9.71c3.09,1.79,5.6.34,5.6-3.24A12.38,12.38,0,0,0,166.4,376.11Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M154.35,384.44a.73.73,0,0,1,.14-.16l7.15-7.87v0l.06-.06.13-.14.07-.08h0c1-1,2.64-1.06,4.48,0a12.38,12.38,0,0,1,5.6,9.7c0,2.08-.85,3.43-2.16,3.86h0l-.08,0a3,3,0,0,1-.41.09l-.09,0h0l-10.36,2.26a2.51,2.51,0,0,1-1.81-.39,7.07,7.07,0,0,1-3.21-5.54A2.6,2.6,0,0,1,154.35,384.44Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M246,333.4l0,0,.19-.11a1.45,1.45,0,0,1,1.3.19,4.4,4.4,0,0,1,2,3.45,1.47,1.47,0,0,1-.47,1.2h0l-.25.14-85.17,49.17-5.6-3.24Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#455a64"
    }
  }), React.createElement("path", {
    d: "M171.5,382.86l-7.91,4.57-5.6-3.24L168.7,378A13.57,13.57,0,0,1,171.5,382.86Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f"
    }
  }), React.createElement("path", {
    d: "M151.53,388.17h0L158,381l.17-.19c.72-.72,1.88-.78,3.2,0a8.74,8.74,0,0,1,4,6.86c0,1.46-.59,2.41-1.51,2.72l-.06,0-.26.06L154,392.55h0a1.53,1.53,0,0,1-1-.22,4,4,0,0,1-1.8-3.13A1.42,1.42,0,0,1,151.53,388.17Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M151.53,388.17h0L158,381l.17-.19c.72-.72,1.88-.78,3.2,0a8.74,8.74,0,0,1,4,6.86c0,1.46-.59,2.41-1.51,2.72l-.06,0-.26.06L154,392.55h0a1.53,1.53,0,0,1-1-.22,4,4,0,0,1-1.8-3.13A1.42,1.42,0,0,1,151.53,388.17Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("path", {
    d: "M151.17,389.2a4,4,0,0,0,1.8,3.13,1.45,1.45,0,0,0,1,.21h0l4.8-1.05c.76-.16,1.26-.87,1.26-2a6.37,6.37,0,0,0-2.88-5,1.85,1.85,0,0,0-2.31,0l-.13.14-3.22,3.54h0A1.38,1.38,0,0,0,151.17,389.2Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M153,388.16c-1-.57-1.8-.11-1.8,1a4,4,0,0,0,1.8,3.13c1,.57,1.8.1,1.8-1.05A4,4,0,0,0,153,388.16Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("path", {
    d: "M267.17,321.15a1.39,1.39,0,0,1,1.41.14,4.39,4.39,0,0,1,2,3.43A1.37,1.37,0,0,1,270,326h0l-21,12.1a1.47,1.47,0,0,0,.47-1.2,4.4,4.4,0,0,0-2-3.45,1.45,1.45,0,0,0-1.3-.19Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fafafa"
    }
  }), React.createElement("path", {
    d: "M266.59,322.43a4.41,4.41,0,0,0,2,3.44,1.21,1.21,0,0,0,2-1.15,4.39,4.39,0,0,0-2-3.43,1.21,1.21,0,0,0-2,1.14Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#f5f5f5"
    }
  }), React.createElement("path", {
    d: "M271.16,314h0l.07,0,.1-.05,9.1-4.77a1,1,0,0,1,.21-.11l.05,0h0a4.32,4.32,0,0,1,3.76.43c3.07,1.6,5.55,5.52,5.55,8.73a3.45,3.45,0,0,1-1.64,3.28h0l-9.21,4.83,0,0-.06,0h0a4.3,4.3,0,0,1-3.84-.39c-3.06-1.61-5.55-5.52-5.55-8.74A3.49,3.49,0,0,1,271.16,314Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M271,314h0l.07,0,.08-.05,8.27-4.77.2-.11,0,0h0a3.62,3.62,0,0,1,3.42.43,11.12,11.12,0,0,1,5,8.73,3.55,3.55,0,0,1-1.49,3.28h0l-8.37,4.83,0,0-.05,0h0a3.62,3.62,0,0,1-3.5-.39,11.16,11.16,0,0,1-5-8.74A3.61,3.61,0,0,1,271,314Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.05
    }
  }), React.createElement("path", {
    d: "M274.69,314.23c-2.78-1.61-5-.3-5,2.91a11.16,11.16,0,0,0,5,8.74c2.79,1.61,5.05.3,5.05-2.91A11.15,11.15,0,0,0,274.69,314.23Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("path", {
    d: "M148.88,391.18h0l3.42-2.06h0a.62.62,0,0,1,.67.05,2,2,0,0,1,.93,1.6.68.68,0,0,1-.27.6h0l-3.41,2.06h0a1.38,1.38,0,0,1-.64.16,1.31,1.31,0,0,1-1.31-1.31A1.3,1.3,0,0,1,148.88,391.18Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#455a64"
    }
  }), React.createElement("path", {
    d: "M148.68,391.33h0l.18-.15h0a.69.69,0,0,1,.6.1,2,2,0,0,1,.92,1.6.65.65,0,0,1-.26.59l-.07,0-.07,0a1,1,0,0,1-.42.07,1.31,1.31,0,0,1-1.31-1.31A1.33,1.33,0,0,1,148.68,391.33Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M82.67,400.31l-3.49-2a4.41,4.41,0,0,1-2-3.45V136.29a4.4,4.4,0,0,1,2-3.45l160.4-92.61a4.39,4.39,0,0,1,4,0l3.49,2a4.41,4.41,0,0,1,2,3.45V304.25a4.39,4.39,0,0,1-2,3.45L86.65,400.31A4.37,4.37,0,0,1,82.67,400.31Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M249,45.37c-.13-1-1-1.41-2-.83L86.65,137.15a4.19,4.19,0,0,0-1.41,1.48l-7.48-4.31a4.19,4.19,0,0,1,1.41-1.48L239.58,40.23a4.37,4.37,0,0,1,4,0l3.5,2A4.43,4.43,0,0,1,249,45.37Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), React.createElement("path", {
    d: "M86.3,400.47a.31.31,0,0,1-.12,0l-.2.07-.08,0c-.12,0-.24.06-.37.09h0a4.51,4.51,0,0,1-2.37-.19,3.62,3.62,0,0,1-.44-.2l-3.5-2a4.44,4.44,0,0,1-2-3.45V136.29a4.21,4.21,0,0,1,.58-2l7.48,4.31a4,4,0,0,0-.59,2V399.17a1.62,1.62,0,0,0,.31,1.05,1,1,0,0,0,1.06.34A1.31,1.31,0,0,0,86.3,400.47Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.15
    }
  }), React.createElement("path", {
    d: "M198.94,87.84l-.29-.18-3.31-1.9a12.25,12.25,0,0,0-3.87-1.37c-.57-.13-1.08-.28-1.53-.43a11.62,11.62,0,0,1-1.46-.59l.24-.31h0L185,80.89h0a3.93,3.93,0,0,0-1-.39c-1.41-.35-3.52.47-5.62.23a5.23,5.23,0,0,1-3.82-2.27c-1.28-1.72-2.05-4.73-3.18-7.23l1-1.45a3.07,3.07,0,0,0-.31-.17l-3.43-2a3.76,3.76,0,0,0-1.91-.52,7.32,7.32,0,0,0-3.6,1.17c-8.21,4.75-8.49,16-11.45,23.42s-7.15,9.73-9.43,12.92-2.44,5.55-7.49,12.51-5.25,8.66-5.25,10v10.37l3.74,2.16,67.22-38.83Zm-61.64,40c-.87.49-1.59-.18-1.59-1.53a4.25,4.25,0,0,1,1.59-3.37c.87-.5,1.58.19,1.58,1.54A4.22,4.22,0,0,1,137.3,127.82Zm29.53-29.11a3.38,3.38,0,0,1-5.17-1.58c-2.61.5-4.55-2-4.55-6.34,0-5.1,2.69-10.77,6-12.69a3.38,3.38,0,0,1,5.17,1.59c2.61-.52,4.54,2,4.54,6.33C172.82,91.12,170.15,96.79,166.83,98.71Zm22.33-.84c-.88.51-1.59-.17-1.59-1.52A4.15,4.15,0,0,1,189.16,93c.88-.51,1.59.17,1.59,1.52A4.16,4.16,0,0,1,189.16,97.87Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#455a64"
    }
  }), React.createElement("path", {
    d: "M137,129.67l-7.23-4.17a5.16,5.16,0,0,0-.24,1.61v10.37l3.74,2.16,3.73-2.16Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), React.createElement("path", {
    d: "M144.43,116.73l3.74-8.63-5.94-3.48h0c-1.74,2.41-2.25,4.36-4.59,8.19Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), React.createElement("path", {
    d: "M159.38,99.48l.48-2.52c-1.65-.69-2.75-2.92-2.75-6.17,0-4.33,1.94-9.06,4.55-11.57l-5.18-3c-2.2,5-3,11-4.82,15.47-.38,1-.79,1.83-1.2,2.63Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), React.createElement("path", {
    d: "M198.94,87.84l-.29-.18a15.07,15.07,0,0,0-3.45-1.12A10.72,10.72,0,0,1,189.94,84a7.65,7.65,0,0,0-1.22-.9,3.48,3.48,0,0,0-1-.4c-2.26-.55-6.38,1.92-9.34-1.92a.54.54,0,0,1-.09-.12c-2.07-2.78-2.83-9-5.93-10.83a3.07,3.07,0,0,0-.31-.17c-1.28-.6-2.94-.49-5.22.81-8.21,4.75-8.49,16-11.45,23.42s-7.14,9.73-9.42,12.92-2.43,5.55-7.49,12.51-5.24,8.67-5.24,10v10.38l67.22-38.83V90.45A2.6,2.6,0,0,0,198.94,87.84ZM141,130c-.88.51-1.59-.17-1.59-1.53a4.18,4.18,0,0,1,1.59-3.36c.88-.51,1.58.18,1.58,1.53A4.18,4.18,0,0,1,141,130Zm25.8-31.26a3.38,3.38,0,0,1-5.17-1.58,9.52,9.52,0,0,1-.82-4.19c0-5.09,2.68-10.77,6-12.68a4.74,4.74,0,0,1,1.45-.57c2.61-.52,4.54,2,4.54,6.33C172.82,91.12,170.15,96.79,166.83,98.71ZM192.89,100c-.88.51-1.59-.17-1.59-1.51a4.15,4.15,0,0,1,1.59-3.36c.87-.51,1.58.17,1.58,1.52A4.17,4.17,0,0,1,192.89,100Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f"
    }
  }), React.createElement("path", {
    d: "M172.82,86c0,5.1-2.67,10.77-6,12.69a3.38,3.38,0,0,1-5.17-1.58,5,5,0,0,0,1.45-.57c3.31-1.92,6-7.59,6-12.69a9.59,9.59,0,0,0-.82-4.18C170.89,79.17,172.82,81.68,172.82,86Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M141,130c-.88.5-1.59-.18-1.59-1.52a4.2,4.2,0,0,1,1.59-3.37c.87-.51,1.58.19,1.58,1.53A4.21,4.21,0,0,1,141,130",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M192.89,100c-.88.5-1.59-.17-1.59-1.52a4.2,4.2,0,0,1,1.59-3.37c.87-.5,1.58.19,1.58,1.54a4.2,4.2,0,0,1-1.58,3.35",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M97.06,161.34,236.64,80.75a2.65,2.65,0,0,1,2.39,0l1.35.78a2.64,2.64,0,0,1,1.19,2.07V296.54a2.62,2.62,0,0,1-1.19,2.07L100.8,379.2a2.65,2.65,0,0,1-2.39,0l-1.35-.78a2.63,2.63,0,0,1-1.2-2.07V163.41A2.65,2.65,0,0,1,97.06,161.34Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#f5f5f5"
    }
  }), React.createElement("path", {
    d: "M241.53,83.24c-.15-.49-.61-.65-1.15-.33L100.8,163.5a2.28,2.28,0,0,0-.85.89l-3.74-2.15a2.46,2.46,0,0,1,.85-.9L236.64,80.75a2.65,2.65,0,0,1,2.39,0l1.35.78A2.65,2.65,0,0,1,241.53,83.24Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#fafafa"
    }
  }), React.createElement("path", {
    d: "M100.51,379.33a2.83,2.83,0,0,1-.44.12l-.23,0a3.57,3.57,0,0,1-.73,0,3.17,3.17,0,0,1-.44-.12l-.27-.13-1.34-.77a2.65,2.65,0,0,1-1.19-2.07V163.41a2.32,2.32,0,0,1,.34-1.17l3.74,2.15a2.51,2.51,0,0,0-.35,1.18V378.51C99.6,379.16,100,379.48,100.51,379.33Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M210.13,110.91l-3.72-2.15a4,4,0,0,0-3.73.11c-4.34,1.91-6.22,2.78-8.46,3.72l-1.62.65c-.88.35-2.63.05-2.09-3l5.77-15.53-.09,0-3.65-2.11a1.52,1.52,0,0,0-.61-.22c-.11,0-.25,0-.4,0-2.36-.06-3-15.29-3.05-15.76h0l-.17-.09-3.61-2.08a4,4,0,0,0-2.06-.52,7.59,7.59,0,0,0-3.43,1c-5.67,3-11.4,11.81-12.8,19.74-.88,5-5.91,12.7-8.82,15.54s-3.11,5.2-3.11,5.2l-2.26,12.82-.73,4.11c-.53,3.06-3.67,6-3.67,6L136.11,147c-7.33,6.08-9.4,12.23-10.8,19.83v.06c0,.27,0,.45.13.52a.12.12,0,0,0,.13,0h0l1.5-.85,80.56-46.46a1.74,1.74,0,0,0,.73-1.12s0,0,0,0,0,0,0,0c.46-2.77,1.8-8,1.8-8ZM186.84,87.38c-.87,4.87-4.38,10.31-7.87,12.14-2.41,1.26-4.17.48-4.76-1.74a2.77,2.77,0,0,1-2.64-.34c-1.12-.88,9.14-18.5,10-18.11a3,3,0,0,1,1.55,2.1C186,80.56,187.61,83,186.84,87.38Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#455a64"
    }
  }), React.createElement("path", {
    d: "M137,155.56l-5.87-3.39c-3.4,4.48-4.77,9.19-5.78,14.66v.06c0,.27,0,.45.13.52a.12.12,0,0,0,.13,0h0l4.63-3.66Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), React.createElement("path", {
    d: "M151.1,133.53l8.28,4.77,3.73-21.57-7.46-4.31a7.1,7.1,0,0,0-1.17,2.85l-2.26,12.82-.73,4.11A6.5,6.5,0,0,1,151.1,133.53Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), React.createElement("path", {
    d: "M170.33,84.23a32.32,32.32,0,0,0-3.92,10.3,25.92,25.92,0,0,1-2.92,7.32l7.09,4.1,3.53-8.15a2.74,2.74,0,0,1-2.54-.36c-.58-.46,1.86-5.33,4.47-9.91Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), React.createElement("path", {
    d: "M210.18,110.94l-.05,0a4.08,4.08,0,0,0-3.72.12c-5.32,2.35-6.93,3.12-10.09,4.37-.84.34-2.55.07-2.1-2.81a1.36,1.36,0,0,1,0-.2l.73-4.1,2-11.17s.46-1.76-.7-2.42l-.09,0a2.17,2.17,0,0,0-.93-.2,4.55,4.55,0,0,1-3.33-2.13,8.4,8.4,0,0,1-1.25-6.39c.85-4.79-.08-8.15-2.2-9.4l-.17-.1c-1.37-.73-3.21-.61-5.36.52-5.68,3-11.41,11.81-12.8,19.74-.89,5-5.92,12.71-8.83,15.54s-3.1,5.2-3.1,5.2L156,130.26l-.72,4.1c-.54,3.06-3.68,6-3.68,6l-11.7,8.78a28.23,28.23,0,0,0-9.63,14.57s-4.39,3.41-4.66,3.68h0l1.5-.85,80.79-46.44s.92-.51,1.13-.64,3.46-3.2,3.46-3.2C212.31,113.64,211.53,111.75,210.18,110.94ZM186.84,87.38c-.87,4.87-4.38,10.31-7.87,12.14-2.41,1.26-4.17.48-4.76-1.74a9.14,9.14,0,0,1,0-3.78c.87-4.88,4.39-10.31,7.88-12.13a6.28,6.28,0,0,1,1-.44C186,80.56,187.61,83,186.84,87.38Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f"
    }
  }), React.createElement("path", {
    d: "M186.84,87.38c-.87,4.87-4.38,10.31-7.87,12.14-2.41,1.26-4.17.48-4.76-1.74a6.9,6.9,0,0,0,1-.42c3.5-1.83,7-7.27,7.87-12.15a9.17,9.17,0,0,0,0-3.78C186,80.56,187.61,83,186.84,87.38Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M183.47,81.64h0a1.9,1.9,0,0,1,1.68.82c1.45,2.06.06,7.3-.54,9-.83,2.33-6.25,7.81-7.74,7.81a3.68,3.68,0,0,1-2.45-1.57,9.07,9.07,0,0,1,0-3.64c.85-4.82,4.33-10.18,7.76-12a6.64,6.64,0,0,1,.95-.41l.33,0m0-.23-.37,0a6.28,6.28,0,0,0-1,.44c-3.49,1.82-7,7.25-7.88,12.13a9.14,9.14,0,0,0,0,3.78,3.94,3.94,0,0,0,2.65,1.7h0c1.62,0,7.07-5.53,7.94-8s2.76-10.11-1.36-10.11Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M125.57,167.42l82.28-47.3,1.14-.63c.2-.12,3.45-3.21,3.45-3.21l-82.22,47.46S125.24,167.6,125.57,167.42Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M114.54,200.59v1.87c0,1,.72,1.43,1.6.92L225,140.52a3.54,3.54,0,0,0,1.6-2.76v-1.88c0-1-.72-1.43-1.6-.92L116.14,197.83A3.53,3.53,0,0,0,114.54,200.59Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,211.9v1.87c0,1,.72,1.43,1.6.92L225,151.82a3.53,3.53,0,0,0,1.6-2.76v-1.88c0-1-.72-1.42-1.6-.92L116.14,209.14A3.53,3.53,0,0,0,114.54,211.9Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,223.14V225c0,1,.72,1.43,1.6.92L225,163.07a3.54,3.54,0,0,0,1.6-2.76v-1.88c0-1-.72-1.43-1.6-.92L116.14,220.38A3.53,3.53,0,0,0,114.54,223.14Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,248.05v1.87c0,1,.72,1.43,1.6.92L225,188a3.53,3.53,0,0,0,1.6-2.76v-1.88c0-1-.72-1.42-1.6-.92L116.14,245.29A3.53,3.53,0,0,0,114.54,248.05Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,259.35v1.88c0,1,.72,1.42,1.6.92L225,199.28a3.53,3.53,0,0,0,1.6-2.76v-1.88c0-1-.72-1.43-1.6-.92L116.14,256.59A3.54,3.54,0,0,0,114.54,259.35Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,270.6v1.87c0,1,.72,1.43,1.6.92L225,210.52a3.53,3.53,0,0,0,1.6-2.76v-1.88c0-1-.72-1.42-1.6-.92L116.14,267.84A3.53,3.53,0,0,0,114.54,270.6Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,295.5v1.88c0,1,.72,1.42,1.6.92L225,235.43a3.53,3.53,0,0,0,1.6-2.76v-1.88c0-1-.72-1.43-1.6-.92L116.14,292.74A3.54,3.54,0,0,0,114.54,295.5Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,306.81v1.87c0,1,.72,1.43,1.6.92L225,246.73a3.51,3.51,0,0,0,1.6-2.75V242.1c0-1-.72-1.43-1.6-.92L116.14,304.05A3.53,3.53,0,0,0,114.54,306.81Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M114.54,318.05v1.88c0,1,.72,1.42,1.6.92L225,258a3.53,3.53,0,0,0,1.6-2.76v-1.88c0-1-.72-1.43-1.6-.92L116.14,315.29A3.54,3.54,0,0,0,114.54,318.05Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("polygon", {
    points: "139 279.81 195.04 247.46 195.04 248.53 139 280.89 139 279.81",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M183.62,302.76c2.33-1.56,4.93-4.19,4.51-7.3-.25-1.89-1.79-2.62-3.53-1.95-3.41,1.31-5.56,6.44-6.75,9.54-1,2.71-2.37,7.82,1.7,8.69,4.77,1,8.46-6,9.54-9.64.15-.51-.68-.79-.92-.33-.42.83-3.24,6.31-.14,5.62,1.1-.24,1.73-1.95,2.13-2.82.7-1.56,1.05-3.73,2.15-5.07l-.81-.37c.05,1.44,0,2.42,1,3.54a.49.49,0,0,0,.68.11c1.58-1.47,1.69-3.86,3.43-5.19l-.71-.34c0,.46-.21,1.77-.24,2.38,0,.29.39.48.62.39a1.36,1.36,0,0,0,1-.86l-.76-.28c.66,3.53,3.67,0,4.7-1.34,3-4,5.14-8.29,5.22-13.41,0-.41-.77-.62-.78-.13-.07,3.94-1.79,7.55-2.9,11.27-1.19,4-2.18,8.09-3,12.21l.71.26a24.52,24.52,0,0,1,2.2-8.42,16.65,16.65,0,0,1,3.79-6.32l-.66-.25a7.14,7.14,0,0,1-1.6,5.82c-.21.27.26.78.47.51,1.1-1.38,2.91-1.82,4.09-3.16a35,35,0,0,0,2.95-4.76l-.54-.27c-.07,3.36,3.1-1.88,3.53-2.44l-.52-.2c.21.69.49,1.15,1.27,1.16,1.55,0,2.13-2.26,3.3-2.52,0,0,.51.43.69.45a2.93,2.93,0,0,0,1.87-.35,8.7,8.7,0,0,0,3.06-3.42c.18-.32-.43-.72-.63-.37-.77,1.3-3.17,4.75-4.91,3.06-.11-.1-.34-.2-.46-.06-.47.58-3.16,3.66-3.66,2-.06-.2-.35-.42-.51-.2-.41.54-.74,1.14-1.12,1.71-.21.31-1.38,2.28-1.34,1.28,0-.24-.37-.52-.54-.27-1.09,1.67-1.89,3.86-3.41,5.22-1.13,1-2.61,1.38-3.59,2.59l.47.51a7.66,7.66,0,0,0,1.83-6.32.42.42,0,0,0-.66-.25c-1.87,1.72-2.92,4.14-3.85,6.46a25.27,25.27,0,0,0-2.24,8.59c0,.31.63.66.71.26a118.83,118.83,0,0,1,3.29-13.16c1.1-3.48,2.59-6.83,2.66-10.53l-.78-.13a19.39,19.39,0,0,1-3.47,10.7c-.56.87-1.15,1.74-1.79,2.56-.28.37-2.76,3.61-3.08,1.73-.05-.27-.58-.65-.76-.28l-.72.64.62.38c.05-.81.21-1.57.25-2.39,0-.31-.48-.51-.71-.33-1.77,1.35-1.9,3.74-3.49,5.21l.68.11a5.41,5.41,0,0,1-.76-3c0-.35-.54-.69-.81-.37-1.22,1.46-1.6,3.79-2.4,5.49-.44.93-2,3.41-1.5.77a13,13,0,0,1,1.41-3.11l-.92-.33c-.94,3.18-3.45,8-6.88,9-4.38,1.31-3.62-4.12-2.82-6.54a26.94,26.94,0,0,1,4.18-7.82,9.25,9.25,0,0,1,1.12-1.3c.9-.8,1.16-1,2.4-.29s1.3,1.1,1,2.44a7.37,7.37,0,0,1-.82,1.89,12.55,12.55,0,0,1-2.94,3.14c-.16.13.07.56.25.43Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#455a64"
    }
  }), React.createElement("path", {
    d: "M318,240.38c-3.62-.86-7.61,1.72-9.94,7.4s-7,20.2-8,24c-.44,1.7,12.48,16.76,12,16.54-.14-.07,4.21-7.35,4.21-7.35L310,271.32,314,260.85Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M309.62,375.18c-.49.19-.62,1.12-.69,3-.06,1.41-.36,3.86,1.29,4.35s4.06.24,5.12-1.08a65,65,0,0,1,4.09-5.13c1.63-1.76,3.39-3.39,4.05-5.85.6-2.22.1-3.18-1.41-3.83-2.09-.88-5.36,2-7,2.47C313.68,369.49,310.11,375,309.62,375.18Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M309.62,373.46v2.28a5.6,5.6,0,0,0,5.77.16c.1-.22.6-3.27.6-3.27Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M326.6,387.31a38.35,38.35,0,0,0-1,3.72c-.29,1.38-.69,3.69-.2,4.72s2.36,1.71,5.29,1.69c1.89,0,4.84,1.27,6.86,2.4a10.58,10.58,0,0,0,6.55.91c2.6-.31,5.3-1.82,5.72-2.89s-.12-1.6-6.25-4.21c-.06,0-6.46-2.92-9.43-6.19Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M326.6,384.84s0,1.69,0,2.66,1.14,2.41,4.1,2.31c2.08-.08,3.53-.64,3.44-2.35V385Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M307.37,341.82a54.22,54.22,0,0,1,2.79-11.74s-1.29-10.1-2-19.8c-1.33-17.39-.26-23.07,3.16-30.87,0,0,29.17-3,30.06,9.17,1.11,15.1-.36,44.28-.76,49.61s-.9,7.74-2.78,18.88c-1.44,8.48-3.66,27.93-3.66,27.93a8,8,0,0,1-7.54-.16s-2.38-24.28-2.13-30.43A52.28,52.28,0,0,1,326.8,341s-1.81-24.61-2.33-28.53c0,0-.92,7.81-1.32,13.14s-2,10.43-3.52,20.34c-1.34,8.59-3.83,27.8-3.83,27.8-3.87,2.1-6.18-.27-6.18-.27S306.33,349.27,307.37,341.82Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, _ref4), React.createElement("polygon", {
    points: "301.33 196.7 299.96 207.97 290.05 207.08 291.18 194.56 301.33 196.7",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M310.75,246c1.09-3,4.8-6.27,8.61-5.56l2.8.51c.08,2.6,5,3.94,9.86,2.37,1.46.42,2.81.85,4,1.28,3.49,1.25,4.89,7,5,16.74s1.11,33.87,1.11,33.87L338,296.52l-1.9-7.07-.77,8.47a30.37,30.37,0,0,1-14.09-.07c-10.48-2.29-13.74-7.94-13.74-7.94A51.15,51.15,0,0,1,315,271.58C309.76,257.61,309.14,250.43,310.75,246Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ebebeb"
    }
  }), React.createElement("path", {
    d: "M340.28,222.13a8.71,8.71,0,0,0-.75-8.38c-3.33-5.22-9.74-6.11-17.34-4.07a13.47,13.47,0,0,0-9.51,12.24c-.37,5.57,15.18,9.68,14.82,13.5Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M340.61,224.25s2.11,3.38,1.81,3.73a5.27,5.27,0,0,1-1.7.68Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#9a4a4d"
    }
  }), React.createElement("path", {
    d: "M334.18,213.54c2.1,1.16,5.74,3.3,6.48,11.2.76,8.1-1.12,10.86-2.25,11.89-.76.7-4.61.85-6.59.18-2.48-.85-7.84-3.67-10.27-7.91-2.86-5-3.3-11.55.22-14A12.89,12.89,0,0,1,334.18,213.54Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M334.8,213.89s1.66,7.42-.7,12c0,0-1.22-2.91-3.72-2.15s-2.37,4.09-.46,5.84a3.7,3.7,0,0,0,3.84.92,16.61,16.61,0,0,1-3.71,5.6s-7.39,3.29-13.78-3.93c-5.81-6.55-4.73-18,4.16-20.67S334.8,213.89,334.8,213.89Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M313.73,214.66a1.74,1.74,0,0,1,.19,2.45l-2.64-2.27A1.73,1.73,0,0,1,313.73,214.66Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M361.13,262.49c1.44-1.64,2-5.3,3.9-7.8s2.62-4.33,3.38-3.24c1,1.45-1.26,4.34-.76,4.63s2.38,4.1,2.57,6.22-5.42,7.44-5.42,7.44Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M367.49,255.75s6.78-.58,7.77,0,.69,3.52,0,5.32-4.15,3-7.36,5.14C367.9,265.89,367.49,255.75,367.49,255.75Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M335.18,244.33c2.91,1,5.46,2.19,8.18,7.3,3.49,6.57,9.85,19.43,9.85,19.43l7.92-8.57s1.15-1.62,3.29,1.92,1.2,4.52,1.2,4.52-9.21,12.34-10.9,13.91-4.47.35-6.29-2.12-13.25-16.78-13.25-16.78S328.93,255.72,335.18,244.33Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#b16668"
    }
  }), React.createElement("path", {
    d: "M324.47,312.45l-.56-5.89a22.38,22.38,0,0,1-8.9-3.37s1.9,3,7.1,4.42l.54,7.5.32,12.3Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.2
    }
  }), React.createElement("path", {
    d: "M303.7,242.77h0A10.27,10.27,0,0,0,314,232.51V216.92h0a7.84,7.84,0,0,0-10.26,7.46Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M341.24,271.55s-5.69-7.34-7.51-10.29l7.71,16.28Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), React.createElement("path", {
    d: "M391.13,211.27c-2.16,6.37-6.77,25.37-6.77,25.37s-8.79,11.69-11.21,13.92c-1.34,1.24-4.37,3.47-4.37,3.47l2.52,1.86s4.2-1.28,4.55,1a127.93,127.93,0,0,0,12.4-11.4,8,8,0,0,0,2-3.66L394,225.7s0-13,2-14.7,1.21-5.55,1.21-5.55C395.84,205.49,392.83,206.28,391.13,211.27Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ffa8a7"
    }
  }), React.createElement("path", {
    d: "M397.28,204.81a36.14,36.14,0,0,0,2.22,5c.88,1.51-5.85,28.66-6.3,30.68s-13.5,13.79-13.5,13.79a9.8,9.8,0,0,1-5.22-5.24l9.42-12.26s2.93-12.86,4.47-18.76S391.55,205.45,397.28,204.81Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M397.28,204.81a36.14,36.14,0,0,0,2.22,5c.88,1.51-5.85,28.66-6.3,30.68s-13.5,13.79-13.5,13.79a9.8,9.8,0,0,1-5.22-5.24l9.42-12.26s2.93-12.86,4.47-18.76S391.55,205.45,397.28,204.81Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("rect", {
    x: 386.76,
    y: 292.65,
    width: 6.5,
    height: 11.14,
    style: {
      fill: "#ffa8a7"
    }
  }), React.createElement("polygon", {
    points: "366.66 295.35 360.16 295.57 359.83 283.79 366.66 283.57 366.66 295.35",
    style: {
      fill: "#ffa8a7"
    }
  }), React.createElement("path", {
    d: "M423.93,252.91c0,6.21.43,42.33.43,42.33.15,1.78,1.87,5,2,11.4.19,9.34-1.25,31.33-1.25,31.33a8.56,8.56,0,0,1-7.24.14s-5.11-31.1-6.27-40.35c-1-8.06-4.53-29.59-4.53-29.59l-5,27.26a37,37,0,0,1,.81,10.34c-.31,4.27-4.27,25.68-4.27,25.68a8.88,8.88,0,0,1-7.51.58s-.39-33.61-.46-37.53c-.09-4.47,1.86-42.94,1.86-42.94Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#37474f"
    }
  }), React.createElement("path", {
    d: "M418.34,340.33v-.93c-.35,0-.56.34-.7,1.17a16.88,16.88,0,0,1-.38,1.84,21.85,21.85,0,0,1-1.13,3.33c-.92,2.27-1.69,3.11-3.8,5.76a24.6,24.6,0,0,0-2,2.33c-.39.7-.53,2.64.14,3.09,2.45,1.64,6.18,1.68,8.82.91a5.34,5.34,0,0,0,3.83-4.3c.1-.6.06-1.22.13-1.82a8.68,8.68,0,0,1,1.63-3.78,11.66,11.66,0,0,0,1.25-2.06c.54-1.33.11-2.84-.24-4.17-.3-1.15-.63-2.41-1-2.3v.7a5.1,5.1,0,0,1-3.26,1.1C420.64,341.24,418.33,341.05,418.34,340.33Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M391.67,333.32c-.34,0-.61.49-1.36,1.3a14.37,14.37,0,0,1-3.82,2.75c-2.44,1.22-7.17,3.09-9.32,4.06-1.34.6-1.27,2.22.11,3.14s4.73,1.58,8.74.69c2.18-.49,5-2.51,6.83-2.4s5.17.08,6.5-.84.8-2.87.42-4.55c-.41-1.83-.92-4.7-1.53-4.57v.63c-.78,1.19-4.82,1.67-6.53.8Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M407.08,268.17A24.15,24.15,0,0,1,398,263s1.75,3.28,7,6.32l-2.52,24.25Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M412.65,205.25c2.22.54,6.68,1.27,7.68,5.68,1.2,5.29,1.59,16.82,1.59,16.82l.41,25.66c-4.48,3.26-20.93,5-30.36-1.85,0,0,1.16-30.8,1.16-35.6s2.66-10.56,10-11Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#f5f5f5"
    }
  }), React.createElement("path", {
    d: "M403.25,204.48a13.1,13.1,0,0,0-4.2,6.5c-.9,3.88-1,47.21-1,47.21s-4.6-.85-6.75-2.54c0,0,.27-34.2.71-39.86.67-8.57.6-11,11.27-11.95Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M414.59,203.84s-6.13,3.77-6.2,18.78c-.06,13-.49,35.57-.49,35.57s10.15,1.49,16.58-2.35c0,0,.77-31.46.64-36.33-.14-5.58-1.44-12.79-3.23-13.51A51.08,51.08,0,0,0,414.59,203.84Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M437.39,238.3c-6.1-24.94-10.61-33.26-18-33.16-2.17,2.58-1.57,10.4,1.85,15.14,0,0,7.63,16.08,8.84,21.8,1.07,5,2.28,11.35,2.21,15.67a3.15,3.15,0,0,1-.85,2.05c-1.39,1.51-1.4,2.73-2.3,4.4-.71,1.3-1.48,1.79-1.26,2.09a1.7,1.7,0,0,0,2.29.17,8.74,8.74,0,0,0,1.73-1.67,17.41,17.41,0,0,1-1.37,4.63c-1.57,3.53-1.19,5.33,3.58,4.07,3-.79,4.86-3.27,5.3-10.45a54.44,54.44,0,0,0,.08-7.94C438.84,248.3,438.38,242.32,437.39,238.3Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ffa8a7"
    }
  }), React.createElement("path", {
    d: "M418.1,204.73s4.91-.22,7.57,2.47,6.25,8.35,9.73,20.72,4.55,21.41,4.72,28.37c0,0-4.36,2-8.38-.28,0,0-1.78-10.77-3.36-16.5s-7.47-17.8-7.47-17.8S415.28,213.34,418.1,204.73Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M418.1,204.73s4.91-.22,7.57,2.47,6.25,8.35,9.73,20.72,4.55,21.41,4.72,28.37c0,0-4.36,2-8.38-.28,0,0-1.78-10.77-3.36-16.5s-7.47-17.8-7.47-17.8S415.28,213.34,418.1,204.73Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("polygon", {
    points: "383.69 172.29 380.89 175.77 382.29 179.72 378.6 189.18 383.05 179.72 381.49 175.99 383.69 172.29",
    style: {
      opacity: 0.1
    }
  }), React.createElement("polygon", {
    points: "363.89 171.18 364.5 174.77 362.07 177.93 365.45 188.58 362.83 178.05 365.08 175.09 363.89 171.18",
    style: {
      opacity: 0.1
    }
  }), React.createElement("circle", {
    cx: 402.13,
    cy: 183.87,
    r: 8.94,
    transform: "translate(124.63 511.6) rotate(-80.78)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M417.58,190.23s-1.45,6.81-2,7.93a3.09,3.09,0,0,1-1.78,1.43l.1-4.79Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M415.76,180.48a3.35,3.35,0,0,1,2.78,1c1.19,1.22.53,5-1,8.77l-2.73.31Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M414,190.55c.55.32,1.33-.73,2-1.43a2.37,2.37,0,0,1,4,.64c1.12,2.36-1,5.48-2.7,6-3,.94-3.44-1-3.44-1l-.22,11.11h0c-2.07,2.65-6.71,5.77-9.21,5.32-2-.35-2.43-3.72-.52-5.93V202a18.61,18.61,0,0,1-4,.2c-2.2-.34-3.58-2.07-4.25-4.45-1.07-3.82-1.48-6.9-.57-14.42,1-8.24,10.58-8.32,15.75-5.07S414,190.55,414,190.55Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ffa8a7"
    }
  }), React.createElement("path", {
    d: "M414,191.47c.28,0,1.33-1.73,2-2.35.94-.86-.28-8.64-.28-8.64a3.77,3.77,0,0,0-.65-4.2c-1.29-1.42-3.09-3.16-9-2.46-4.18.49-8.73,1.79-12.41,0a6.26,6.26,0,0,0,2.18,6.65,12.47,12.47,0,0,0,4.83,1.28,51.67,51.67,0,0,0,9.7-.18c1-.14,1.23.84,1.78,3.53C412.71,187.45,413.11,191.45,414,191.47Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M415.76,181.09l3.31-1.78a1.83,1.83,0,0,0-2.51-.83A2,2,0,0,0,415.76,181.09Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M403.93,202a37.89,37.89,0,0,0,6.62-1.9,5.64,5.64,0,0,0,2.37-2.35,7.67,7.67,0,0,1-1.35,2.77c-1.25,1.6-7.64,2.78-7.64,2.78Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#f28f8f"
    }
  }), React.createElement("path", {
    d: "M405.11,189.32a1,1,0,1,0,2,0,1,1,0,0,0-1-1A1,1,0,0,0,405.11,189.32Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M406.15,185.61l2.1,1.16a1.27,1.27,0,0,0-.49-1.68A1.17,1.17,0,0,0,406.15,185.61Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M404.37,196.11l-2.24.84a1.17,1.17,0,0,0,1.52.75A1.26,1.26,0,0,0,404.37,196.11Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#f28f8f"
    }
  }), React.createElement("path", {
    d: "M396.34,186.43l1.92-1.48a1.17,1.17,0,0,0-1.67-.26A1.28,1.28,0,0,0,396.34,186.43Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("path", {
    d: "M396.93,189a1,1,0,1,0,2,0,1,1,0,0,0-1-1A1,1,0,0,0,396.93,189Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#263238"
    }
  }), React.createElement("polygon", {
    points: "370.36 148.35 370.03 154.27 366.94 153.22 370.36 148.35",
    style: {
      fill: "#f28f8f"
    }
  }), React.createElement("path", {
    d: "M400.87,210.55c.6,1.44,1.72,2,3.73,2.25a7.51,7.51,0,0,0,5.58-2l-2.5-2.49-3.19,2.39-.27-2.67Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M400.87,210.55c.6,1.44,1.72,2,3.73,2.25a7.51,7.51,0,0,0,5.58-2l-2.5-2.49-3.19,2.39-.27-2.67Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("path", {
    d: "M402.45,209.77a6.6,6.6,0,0,0-.33,2.69,4.57,4.57,0,0,0,.9,2.23,2.44,2.44,0,0,0,2.16.24,5.94,5.94,0,0,0,2.07-4.49l-2.76.31Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M403,214.69s-3.27,18-3.4,19.48,1.87,6.62,3.12,6.66,3.69-4.63,3.72-6-1.28-19.95-1.28-19.95Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#dc2445"
    }
  }), React.createElement("path", {
    d: "M405.18,214.93a2.16,2.16,0,0,1-2.16-.24l0,.29a2.48,2.48,0,0,0,2.25.44Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      opacity: 0.1
    }
  }), React.createElement("path", {
    d: "M404.49,210.75l9.2-7,0-2.08s2.14.81,2.62,4.58a16.14,16.14,0,0,1-7.17,7.63l-1.93-3.44Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#eaeaea"
    }
  }), React.createElement("path", {
    d: "M403.93,202.62a4.61,4.61,0,0,0-3,1.83c-.92,1.51-.71,7.32-.71,7.32l2.2-2,2,1c-.19-1.93-.57-5.45-.57-5.45Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#eaeaea"
    }
  }), React.createElement("path", {
    d: "M368,266.27a7.9,7.9,0,0,0,1.45-4.11c.26-1.89,5.44-3.92,5.61-2.51s.64,2.58-1,4.29S370.41,267.54,368,266.27Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ffa8a7"
    }
  }), React.createElement("path", {
    d: "M368.27,254.06c-1.24,1.6-2,4.71-2.66,5.76s-1.44,2,0,2.15,3.53-2.61,4.31-4.31a4.6,4.6,0,0,1,1.34-1.72,3,3,0,0,1,.75-.44c-.67-.23-.32-2.93-.79-3.3C371.22,252.2,368.78,253.2,368.27,254.06Z",
    transform: "translate(-31.58 -39.75)",
    style: {
      fill: "#ffa8a7"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background.9f427dbc.svg";
export { ForwardRef as ReactComponent };